import React, { Component } from 'react';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';

class LoginContainer extends Component {
  render() {
    return (
      <div>
        <h1><T>content.login.title</T></h1>
        { this.props.children }
        <h1><T>content.login.footer</T></h1>
      </div>
    );
  }
}
export default LoginContainer;